<template>
    <div class="sparkling-container">
        <div class="sparkling-target">
            <slot></slot>
        </div>
        <div :id="targetId"></div>
    </div>
</template>

<script>
import {onMounted, onUnmounted, ref } from '@vue/composition-api';

export default {
    props: {
        spark: {
            type: Boolean,
            default: true
        }
    },
    setup(props) {
        const targetId = ref(null);
        const sparklesInterval = ref(null);

        onMounted(() => {
            targetId.value = `spark-container-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`
            if (props.spark) {
                actions.startSparkling();
            }
        });

        onUnmounted(() => {
            actions.stopSparkling();
        });

        const actions = {
            startSparkling() {
                sparklesInterval.value = setInterval(() => {
                    const sparkle = document.createElement('div');
                    sparkle.classList.add('spark');

                    sparkle.style.top = `${1 + Math.random() * 100}%`;
                    sparkle.style.left = `${1 + Math.random() * 100}%`;

                    const container = document.querySelector(`#${targetId.value}`);
                    container.appendChild(sparkle);

                    setTimeout(() => {
                        container.removeChild(sparkle);
                    }, 1000);
                }, 100);
            },
            stopSparkling() {
                if (sparklesInterval.value) {
                    clearInterval(sparklesInterval.value);
                }
            },
        };

        return {
            targetId,
            actions,
        };
    },
};
</script>

<style lang="scss">
.sparkling-container {
    width: 100%;
    position: relative;
    display: inline-block;
}

.sparkling-target {
    width: 100%;
    background-color: transparent;
    color: #fff;
    border-radius: 8px;
    text-align: center;
}

.spark-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
}

.spark {
    position: absolute;
    width: 6px;
    height: 6px;
    background-color: #fff;
    border-radius: 50%;
    clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
    opacity: 0;
    animation: sparkle 1s ease-in-out infinite;
}

@keyframes sparkle {

    0%,
    100% {
        opacity: 0;
    }

    50% {
        opacity: 1;
        transform: scale(2);
    }
}
</style>
